import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IAddressField {
	changeAddress: (value: string) => void;
}

const AddressField: React.FC<IAddressField> = ({ changeAddress }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAddress') }], [t]);

	return (
		<FormInput
			testId="AddressField"
			name="address"
			label="addressLabel"
			onChange={changeAddress}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(AddressField);
